export default {
  USER: { 
    permissions: {}, 
    config: { 
      neverAskActions: [] 
    } 
  },
  ajaxCallsInProgress: 0
};



// WEBPACK FOOTER //
// ./src/configurations/initialValues.js